export default "__VITE_ASSET__B2ux1Lc$__"